<script>
import JobBox from "ninenine-white-label/src/components/JobBox/JobBox.vue";
import FiltersBadges from "@/components/jobs/FiltersBadges.vue";
import SpinnerLoader from "ninenine-white-label/src/components/Loader/SpinnerLoader";
import MagnifyIcon from "vue-material-design-icons/Magnify.vue";

export default {
  name: "Jobs",

  data() {
    return {
      page: 0,
      searchState: "",
      searchCity: "",
      searchCollection: "",
      endResults: false,
      isLoading: false,
      selectedState: null,
      selectedCity: null,
      selectedLevel: null,
      selectedCollection: null,
      selectedPCD: false,
      selectedTeam: this.$route.query.area || null,
      typingJobName: null, // jobName enquanto digita
      jobName: this.$route.query.busca || null, // jobName após o enter
      selectedArea: null,
      areaStudio: ["Nós", "Race", "Vidya", "Tonus", "JAB"],
      stateSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: "body",
      },
      citySettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: "body",

        score: function scoreFilter(search) {
          var text = search.toString();
          var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
          var to = "aaaaaeeeeeiiiiooooouuuunc------";

          for (var i = 0, len = from.length; i < len; i++) {
            text = text.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
          }

          var score = this.getScoreFunction(text);
          return function onScore(item) {
            var result = score(item);
            return result;
          };
        },
      },

      levelSettings: {
        create: false,
        createOnBlur: false,
        dropdownParent: "body",
      },
    };
  },

  props: ["search"],

  computed: {
    syncdSearch: {
      get() {
        return this.search;
      },
      set(value) {
        this.$emit("update:search", value);
      },
    },
    brands() {
      return this.$store.state.brands;
    },
    opportunities() {
      let opportunities = this.$store.state.opportunities.all;

      opportunities.sort((a, b) => {
        if (a.title > b.title) return 1;
        if (a.title < b.title) return -1;
        return 0;
      });

      return opportunities;
    },
    levels() {
      return this.$store.state.domains.professional_experience_levels || [];
    },

    states() {
      return this.$store.state.domains.states;
    },

    cities() {
      return this.$store.state.domains.cities;
    },

    teamInfos() {
      return (
        this.$store.state.teams.find(
          (team) => team.slug == this.selectedTeam
        ) || {}
      );
    },
  },

  watch: {
    selectedState: function(newValue, oldValue) {
      this.getCities();
      this.clearFiltersAndGet();
    },

    selectedArea: function(newValue, oldValue) {
      this.clearFiltersAndGet();
    },

    selectedCity: function(newValue, oldValue) {
      this.clearFiltersAndGet();
    },

    selectedLevel: function(newValue, oldValue) {
      this.clearFiltersAndGet();
    },

    selectedPCD: function(newValue, oldValue) {
      this.clearFiltersAndGet();
    },

    selectedTeam: function(newValue, oldValue) {
      this.clearFiltersAndGet();
    },
    $route() {
      this.syncdSearch = this.$route.query.busca;
    },
    syncdSearch: function(newValue, oldValue) {
      window.scrollTo(0, 400);
      this.clearFiltersAndGet();
    },
  },

  components: {
    JobBox,
    FiltersBadges,
    SpinnerLoader,
    MagnifyIcon,
  },

  mounted() {
    // Remove o autofill para não atrabalhar o selectize
    setTimeout(() => this.removeAutoFillSelectize(), 500);

    // Busca as oportunidades
    this.clearFiltersAndGet();

    // Busca os níveis possíveis para fazer o filtro de oportunidades
    if (this.$store.state.domains.professional_experience_levels.length == 0) {
      this.$store.dispatch(
        "graphql_queries/query",
        `domains { professionalExperienceLevels {id, name} }`
      );
    }
  },

  methods: {
    submitJobName() {
      this.syncdSearch = this.typingJobName;
    },
    clearFiltersAndGet() {
      this.$store.commit("opportunities/CLEAR_OPPORTUNITIES");
      this.page = 0;
      this.endResults = false;
      this.getJobs();
    },

    async getJobs() {
      ++this.page;
      this.isLoading = true;

      let idStates = {
        AC: "2",
        AL: "3",
        AP: "4",
        AM: "5",
        BA: "6",
        CE: "7",
        DF: "8",
        ES: "9",
        GO: "10",
        MA: "11",
        MT: "12",
        MS: "13",
        MG: "14",
        PA: "15",
        PB: "16",
        PR: "17",
        PE: "18",
        PI: "19",
        RJ: "20",
        RN: "21",
        RS: "22",
        RO: "23",
        SC: "24",
        RR: "25",
        SP: "26",
        SE: "27",
        TO: "28",
      };
      let params = {
        collection:
          this.$route.params.group == "corporativas"
            ? "corporativo"
            : this.selectedCollection ||
              this.$route.params.group.toLowerCase().replace(/( )+/g, "-"),
        company_area: this.selectedArea,
        page: this.page,
        pcd: this.selectedPCD,
        states: idStates[this.selectedState],
        city: this.selectedCity,
        level: this.selectedLevel,
        jobName: this.syncdSearch || this.$route.query.busca,
      };
      const opportunities = await this.$store.dispatch(
        "opportunities/setOpportunities",
        params
      );
      this.endResults = opportunities.length < 20;
      this.isLoading = false;
    },

    getCities() {
      const params = {
        states: this.selectedState,
      };

      if (params.states && params.states.length > 0) {
        this.$store.dispatch("location/setCities", params);
      }
    },

    checkState() {
      if (this.$route.params.group == "corporativas") {
        let state = [
          { id: "26", name: "São Paulo", abbr: "SP", estado: "São Paulo" },
          { id: "10", name: "Goiás", abbr: "GO", estado: "Goiás" },
          { id: "17", name: "Paraná", abbr: "PR", estado: "Paraná" },
        ];

        return state.filter(
          (data) =>
            !this.searchState ||
            data.name.toLowerCase().includes(this.searchState.toLowerCase())
        );
      } else {
        return this.states.filter(
          (data) =>
            !this.searchState ||
            data.name.toLowerCase().includes(this.searchState.toLowerCase())
        );
      }
    },
  },
};
</script>

<template>
  <div class="job-list container mb-5">
    <div>
      <FiltersBadges
        :jobName="syncdSearch || jobName"
        @resetJobName="
          syncdSearch = null;
          jobName = null;
          typingJobName = null;
        "
        :selectedCollection="selectedCollection || null"
        @resetCollection="(selectedCollection = null), clearFiltersAndGet()"
        :selectedStates="selectedState ? [selectedState] : []"
        @resetState="selectedState = null"
        :selectedCities="selectedCity ? [selectedCity] : []"
        @resetCity="selectedCity = null"
        :selectedLevel="selectedLevel"
        @resetLevel="selectedLevel = null"
        :selectedPCD="selectedPCD"
        @resetPCD="selectedPCD = false"
        :selectedTeam="selectedTeam"
        @resetTeam="selectedTeam = null"
      />
    </div>
    <section class="row">
      <div class="job-list__filter col-md-6 col-lg-3">
        <aside class="mb-4 mb-m-0">
          <div class="box">
            <h3>LOCALIZAÇÃO</h3>
            <div class="input-group-filter">
              <input
                type="text"
                v-model="searchState"
                class="font-sans-serif-regular"
                placeholder="Filtre pelo Estado"
              />
              <div class="input-append">
                <button type="button" @click="submitJobName()">
                  <magnify-icon class="h4 my-0 text-muted" />
                </button>
              </div>
            </div>
            <ul>
              <li v-for="(state, index) in checkState(states)" :key="index">
                <b-form-checkbox
                  v-model="selectedState"
                  :name="state.name"
                  :value="state.abbr"
                >
                  {{ state.name }}
                </b-form-checkbox>
              </li>
            </ul>
            <div class="input-group-filter">
              <input
                type="text"
                v-model="searchCity"
                class="font-sans-serif-regular"
                placeholder="Filtre pela Cidade"
              />
              <div class="input-append">
                <button type="button" @click="submitJobName()">
                  <magnify-icon class="h4 my-0 text-muted" />
                </button>
              </div>
            </div>
            <ul>
              <li
                v-for="(city, index) in cities.filter(
                  (data) =>
                    !searchCity ||
                    data.name.toLowerCase().includes(searchCity.toLowerCase())
                )"
                :key="index"
              >
                <b-form-checkbox
                  v-model="selectedCity"
                  :name="city.cidade"
                  :value="city.name"
                >
                  {{ city.cidade }}
                </b-form-checkbox>
              </li>
            </ul>
          </div>
          <div class="box mt-4" v-if="$route.params.group == 'lojas'">
            <h3>MARCAS</h3>
            <div class="input-group-filter">
              <input
                type="text"
                v-model="searchCollection"
                class="font-sans-serif-regular"
                placeholder="Filtre por marca"
              />
              <div class="input-append">
                <button type="button" @click="submitJobName()">
                  <magnify-icon class="h4 my-0 text-muted" />
                </button>
              </div>
            </div>
            <ul>
              <li
                v-for="(brand, index) in brands.filter(
                  (data) =>
                    !searchState ||
                    data.name.toLowerCase().includes(searchState.toLowerCase())
                )"
                :key="index"
              >
                <b-form-checkbox
                  v-model="selectedArea"
                  :name="brand.name"
                  :value="brand.id"
                >
                  {{ brand.name }}
                </b-form-checkbox>
              </li>
            </ul>
          </div>
        </aside>
      </div>
      <div class="col-md-6 col-lg-9">
        <div class="row">
          <JobBox
            :opportunity="opportunity"
            v-for="(opportunity, id) in opportunities"
            :key="id"
            :id="id"
            :btnSubscriptionText="'Inscreva-se'"
            :showDescriptionPage="false"
            :showModalKnowMoreButton="true"
            class="col-12 col-lg-4 mb-4"
          />

          <div class="col-12">
            <SpinnerLoader v-if="isLoading" />

            <button
              @click="getJobs()"
              class="btn btn-color-1 d-block mx-auto"
              v-if="!isLoading && !endResults"
            >
              Carregar mais
            </button>

            <div v-if="!isLoading && !opportunities.length">
              <p class="text-muted text-center">
                Nenhum resultado encontrado para esse filtro:
              </p>
            </div>

            <div v-if="!isLoading && opportunities.length && endResults">
              <p class="text-muted text-center">
                Todas as oportunidades foram listadas
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style lang="scss" scoped>
.job-list {
  aside {
    .box {
      background-color: #fff;
      box-shadow: 0px 3px 25px #00000029;
      border-radius: 5px;
      box-sizing: border-box;
      padding: 1.5rem;
    }
    h3 {
      font-size: 1rem;
      font-weight: 400;
      margin-bottom: 1rem;
    }
    .input-group-filter {
      display: flex;
      align-items: center;
      width: 100%;
      opacity: 0.8;
      input {
        border: 1.8px solid rgba(#000, 0.4);
        height: 38px;
        border-radius: 4px;
        padding: 0px 2rem 0px 1rem;
        width: 100%;
        box-sizing: border-box;
      }
      button {
        margin-left: -2.5rem;
        display: block;
        border: none;
        background-color: transparent;
        margin-top: 0.3rem;
        opacity: 0.6;
      }
    }
  }
  ul {
    padding: 0px;
    margin: 0px;
    overflow-y: auto;
    max-height: 132px;
    margin: 1rem 0px;
    li {
      margin-bottom: 0.8rem;
      font-size: 1.2rem;
      color: #000;
    }
    &::-webkit-scrollbar {
      width: 6px;
      border-radius: 40px;
      background-color: rgba(#000, 0.1);
    }
    &::-webkit-scrollbar-thumb {
      width: 6px;
      border-radius: 40px;
      background-color: #000;
    }
  }
}

.job-list {
  @include media-breakpoint-down(md) {
    h2 {
      margin-top: -5rem;
    }
  }
}
h1 {
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 62px;
  &:before,
  &:after {
    content: "";
    width: auto;
    height: 4px;
    background: theme-color("color-1");
    flex-grow: 1;
    border-radius: 30px;
  }
  &:before {
    margin-right: 60px;
    @include media-breakpoint-down(md) {
      margin-right: 15px;
    }
  }
  &:after {
    margin-left: 60px;
    @include media-breakpoint-down(md) {
      margin-left: 15px;
    }
  }
}

/deep/ select.rounded-xl + .selectize-control {
  & > .selectize-input {
    border-radius: inherit;
  }
}
</style>
